
document.addEventListener('DOMContentLoaded', function () {
  new Splide('#splide-pan', {
    type: 'slide',
    perMove: 4,
    perPage: 4,
    gap: '35px',
    arrows: true,
    pagination: false,
    autoplay: true,
      interval: 4000,
      pauseOnHover: true,
      pauseOnFocus: false,
    speed: 800,
    breakpoints: {
      768: { perPage: 2 },
      480: { perPage: 1,
        perMove:1
       }
    }
  }).mount();

  new Splide('#splide-bengal', {
    type: 'slide',
    perMove: 4,
    perPage: 4,
    gap: '35px',
    arrows: false,
    pagination: false,
    autoplay: true,
    breakpoints: {
      1200: { 
        perPage: 3, 
        gap: '20px' 
      },
      991: { 
        perPage: 2,
        arrows: false,
        pagination: true 
      },
      480: { perPage: 1 }
    }
  }).mount();
  
});
